import { useTranslation } from "@opendash/core";
import { Icon } from "@opendash/icons";
import { RouteProps } from "@opendash/router";
import { Button, Col, Result, Row, Spin } from "antd";
import { observer } from "mobx-react-lite";
import React, { useContext } from "react";
import { AgencyCreateModal } from "../../components/AgencyCreateModal";
import { RouteCard } from "../../components/RouteCard";
import { RouteCreateModal } from "../../components/RouteCreateModal";
import { PseudoRouteCard } from "../../components/UI/PseudoRouteCard";
import UserGuide from "../../components/UI/UserGuide";
import { AgencyContext } from "../../contexts/AgencyContext";
import { Route } from "../../js/parsegenerated";
import { TourId } from "../../types/TourId";
import { HomePageState } from "../HomePageState";

export const HomePage = observer(({ state }: RouteProps<HomePageState>) => {
  const t = useTranslation();
  const agencyState = useContext(AgencyContext);
  const [createModalVisible, setCreateModalVisible] =
    React.useState<boolean>(false);
  React.useEffect(() => {
    if (agencyState.selectedAgency?.id) {
      state.fetchRoutes(agencyState.selectedAgency);
    }
  }, [agencyState.selectedAgency?.id]);

  return (
    <div>
      {!agencyState.selectedAgency && !agencyState.loading && (
        <>
          <UserGuide.Agency />
          <Result
            status="warning"
            title="Es existiert noch keine Agency. Bitte legen Sie eine Agency an."
            extra={
              <Button
                id={TourId.Agency.create}
                type="primary"
                key="console"
                style={{ width: "200px" }}
                onClick={() => {
                  setCreateModalVisible(true);
                }}
                icon={<Icon icon="fa:plus" />}
              />
            }
          />
          <AgencyCreateModal
            open={createModalVisible}
            onOk={() => {
              setCreateModalVisible(false);
              window.location.reload();
            }}
            onCancel={() => {
              setCreateModalVisible(false);
            }}
          ></AgencyCreateModal>
        </>
      )}
      {agencyState.selectedAgency && !agencyState.loading && (
        <div>
          <UserGuide.Route />
          <p>
            Legen Sie hier Ihre Fahrpläne an und exportieren Sie diese in das
            (Standard)format GTFS.
          </p>
          <p>
            Weitere Informationen zu GTFS finden Sie in der Dokumentation bei
            Google{" "}
            <a
              href="https://developers.google.com/transit/gtfs/reference"
              target="_blank"
              rel="noreferrer"
            >
              Google <Icon icon="fa:external-link" />
            </a>{" "}
            und bei{" "}
            <a
              href="https://de.wikipedia.org/wiki/General_Transit_Feed_Specification"
              target="_blank"
              rel="noreferrer"
            >
              Wikipedia <Icon icon="fa:external-link" />
            </a>
            .
          </p>
          <Button
            id={TourId.Route.create}
            type="primary"
            onClick={() => {
              state.setCreateModalVisible(true);
            }}
            style={{
              marginRight: 10,
              marginBottom: 10,
            }}
          >
            {t("gtfs:route.create.button")}
          </Button>
          <Row gutter={[16, 16]} id={TourId.Route.overview}>
            {state.loading ? <Spin /> : null}
            <PseudoRouteCard />

            {state.routes.map((route: Route) => (
              <Col xs={24} sm={24} md={12} lg={8} xl={6} key={route.id}>
                {route ? (
                  <RouteCard
                    route={route}
                    reload={() => state.fetchRoutes(agencyState.selectedAgency)}
                  />
                ) : null}
              </Col>
            ))}
          </Row>

          <RouteCreateModal
            open={state.createModalVisible}
            onOk={() => {
              state.setCreateModalVisible(false);

              state.fetchRoutes(agencyState.selectedAgency);
            }}
            onCancel={() => {
              state.setCreateModalVisible(false);
            }}
          />
        </div>
      )}
    </div>
  );
});
